module.exports = __webpack_public_path__ + "img/new-check.7ff6526d.svg";